/* rs-editorial.js — fallback de reveal y lógica del shopbar.
   Spec: rs-brain/docs/skills/rs-brand/references/ds-editorial.md

   >>> ESTE ARCHIVO NO HACE EL "FLOW". El pineo de los paneles y el reveal
   atado al scroll son CSS puro: `position:sticky` y `animation-timeline:
   view()`. En un navegador moderno la única parte de este archivo que corre
   es la del shopbar.

   REGLA DE ORO: nada de lo que hace acá es necesario para leer la página. Si
   no corre, no se rompe nada. Por eso la clase `rs-ed-js` — la que esconde
   los bloques hasta revelarlos — se agrega ACÁ y solo después de comprobar
   que hace falta Y que se va a poder sacar. La versión vieja ponía opacity:0
   desde el CSS: si el JS fallaba, la página quedaba en blanco. Y con la
   pestaña en segundo plano las transiciones ni siquiera avanzan, así que ese
   blanco duraba hasta que volvías a la pestaña.
   Ver _learnings/2026-09-08-transiciones-css-no-avanzan-con-document-hidden.md
*/
(function () {
  'use strict';

  var roots = document.querySelectorAll('[data-rs-editorial]');
  if (!roots.length) return;

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canObserve = 'IntersectionObserver' in window;
  var hasScrollAnim = !!(window.CSS && CSS.supports && CSS.supports('animation-timeline: view()'));

  Array.prototype.forEach.call(roots, function (root) {
    // El reveal solo necesita JS donde no hay animaciones atadas al scroll.
    if (!hasScrollAnim && !reduced && canObserve) initReveal(root);
    initShopbar(root);
    if (!reduced) initHeroFile(root);
    initSplitVideos(root);
  });

  // Split videos are paused in HTML, so reduced motion also wins before JS
  // loads. Native controls remain available if enhancement cannot run.
  function initSplitVideos(root) {
    const motion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
    for (const media of root.querySelectorAll('.rs-ed-split__media')) {
      const video = media.querySelector('video');
      const button = media.querySelector('.rs-ed-split__video-toggle');
      if (!video || !button) continue;

      function syncControl() {
        button.setAttribute('aria-label', button.getAttribute(video.paused ? 'data-play-label' : 'data-pause-label'));
        button.setAttribute('data-paused', String(video.paused));
      }

      async function play() {
        try {
          await video.play();
        } catch (error) {
          // Browser autoplay policies can refuse playback; keep Play available.
          syncControl();
        }
      }

      video.addEventListener('play', syncControl);
      video.addEventListener('pause', syncControl);
      button.addEventListener('click', function () {
        if (video.paused) play();
        else video.pause();
      });
      syncControl();
      button.hidden = false;
      video.controls = false;

      if (motion) {
        motion.addEventListener('change', function () {
          if (motion.matches) video.pause();
        });
        if (!motion.matches) play();
      }
    }
  }

  // Hero video from a plain file URL. The src is set here, after reading the
  // breakpoint, so each device downloads only its own cut. Same breakpoint
  // as the CSS (821px). If this never runs, the hero keeps its image.
  function initHeroFile(root) {
    var vids = root.querySelectorAll('video.rs-ed-hero__file[data-src]');
    if (!vids.length) return;
    var phone = window.matchMedia && window.matchMedia('(max-width: 820px)').matches;
    Array.prototype.forEach.call(vids, function (v) {
      var src = (phone && v.getAttribute('data-src-mobile')) || v.getAttribute('data-src');
      if (!src) return;
      v.src = src;
      v.preload = 'auto';
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    });
  }

  function initReveal(root) {
    var items = root.querySelectorAll('.rs-ed-fade');
    if (!items.length) return;

    // Recién acá se esconden: ya sabemos que los vamos a poder mostrar.
    root.classList.add('rs-ed-js');

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });

    Array.prototype.forEach.call(items, function (el) { io.observe(el); });

    // Red de seguridad: si algo sale mal, a los 3 s se muestra todo igual.
    // Barato, y evita que un bug de observer deje la página vacía.
    window.setTimeout(function () {
      Array.prototype.forEach.call(items, function (el) { el.classList.add('is-in'); });
    }, 3000);
  }

  /* La shopbar ya no necesita JS: `position: sticky` la fija y la suelta sola.
     Lo único que queda es el scroll suave del click, y respetando a quien
     pidió menos movimiento. La versión anterior tenía acá cuarenta líneas
     — mover el nodo, inyectar un spacer, escuchar scroll con rAF — para
     conseguir exactamente lo mismo. */
  function initShopbar(root) {
    var bar = root.querySelector('[data-rs-shopbar]');
    if (!bar) return;
    var href = bar.getAttribute('href');
    var target = href && href.charAt(0) === '#' ? root.querySelector(href) : null;
    if (!target) return;
    bar.addEventListener('click', function (ev) {
      ev.preventDefault();
      target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
    });
  }
})();
